// REACT
import { useContext } from "react";

// CONTEXT
import { maincontext } from "../context/maincontext";

// ASSETS
import languagePack from "../assets/languages/languagePack";

// COMPONENTS
import ToolHeader from "../components/common/ToolHeader"
import Export from "../components/export/Export";

export default function ExportManager(params) {
    const { language } = useContext(maincontext);

    return (
        <>
            <ToolHeader
                toolHeader={languagePack[language].exportManager.title}
                icon={"export"}
            />
            <Export />
        </>
    )
}